import React from "react";
import Background from "./Background";
import { Register } from "@/features/auth";
import { Login } from "@/features/auth";
import '@/css/shared.css';
import '@/css/auth.css';
import { useNavigate } from "react-router-dom";
import { AUTH, type AuthState } from "@/shared/constants/auth";

function AuthContainer({ authState, changeAuthState, setAuthState, onComplete } : { authState: string, changeAuthState: () => void, setAuthState: (state: AuthState) => void, onComplete: () => void}){
    const navigate = useNavigate();

    return(
        <div className="page-grid">
            <div className="dark-box dark-box-large" style={{ display: 'flex', flexDirection: 'column', transition: '.6s', overflow: 'hidden' }}>
                <div className="nav-header">
                    <button onClick={() => {setAuthState(AUTH.NONE); navigate('/')}} style={{ cursor: 'pointer' }}>
                        <svg width={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" >
                            <path d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" />
                            <path d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" />
                        </svg>
                    </button>
                    <span>{authState === AUTH.REGISTER ? "Register" : "Login"}</span>
                </div>
                <div className="content-wrapper">
                    {authState === AUTH.REGISTER
                    ?
                    <Register
                    onComplete={onComplete}
                    />
                    : 
                    <Login
                    onComplete={onComplete}
                    />
                    }
                    <div style={{ paddingTop: '10px' }}>
                        <button
                            onClick={changeAuthState}
                            className="moreAuth"
                        >
                        {authState === AUTH.REGISTER ? "Have an account? Log in" : "Create an account"}
                        </button>
                    </div>
                </div>
            </div>
        </div>   
    )
}

export default AuthContainer